import { KeyboardEvent } from 'react';

export function handleChatComposerKeyDown(event: KeyboardEvent<HTMLTextAreaElement>, setValue: (value: string) => void, send: () => void) {
  if (event.key !== 'Enter' || event.nativeEvent.isComposing || event.keyCode === 229) return;
  const input = event.currentTarget;
  if (input.disabled || input.readOnly) return;
  event.preventDefault();
  if (event.shiftKey || event.ctrlKey) {
    const start = input.selectionStart, end = input.selectionEnd;
    const next = `${input.value.slice(0, start)}\n${input.value.slice(end)}`;
    if (input.maxLength >= 0 && next.length > input.maxLength) return;
    setValue(next);
    requestAnimationFrame(() => {
      if (document.activeElement === input) input.setSelectionRange(start + 1, start + 1);
    });
  } else if (!event.repeat) send();
}
